import { useEffect } from 'react';

/**
 * Adds a `<meta name="robots" content="noindex,nofollow">` tag while the
 * calling component is mounted, and removes it on unmount. Used on internal
 * POS / staff pages so search engines never list radgameshop.com/pos and the
 * other staff routes — the public storefront stays fully indexable.
 */
const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    meta.setAttribute('data-noindex', 'pos');
    document.head.appendChild(meta);
    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);
};

export default useNoIndex;
